import React from 'react'
import Table from 'react-bootstrap/cjs/Table'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import styled from 'styled-components'

import Icon from 'components/Icon'
import Get from 'components/Get'
import { _ } from 'utils'
import { RetrieveUserResponse } from 'types/swagger'

import { Job } from './types'
import { deleteJob, Slugs, selectJobs } from './jobsSlice'
import openViewEditJob from './openviewEditJob'

const S = {
    Thumbnail: styled.img`
        height: 24px;
        width: 24px;
        margin-right: 12px;
        border-radius: 36px;
    `,
    TextTd: styled.td`
        padding-top: 16px !important;
        white-space: nowrap;
        text-overflow: ellipsis;
    `
}

const Profile = ({ id }: { id: number }) => (
    <Get url={`profiles/${id}/`} hideLoader>
        {(attendee: RetrieveUserResponse) => (
            <span>
                <S.Thumbnail src={attendee.mugshot} alt="" />
                {`${attendee.first_name} ${attendee.last_name}`}
            </span>
        )}
    </Get>
)

const JobRow = ({ job }: { job: Job }) => {
    const params = useParams<Slugs>()
    const dispatch = useDispatch()
    const onView = () => {
        dispatch(openViewEditJob(true, job))
    }
    const onEdit = () => {
        dispatch(openViewEditJob(false, job))
    }
    const onDelete = () => {
        dispatch(deleteJob({ job, ...params }))
    }
    return (
        <tr key={job.id}>
            <S.TextTd>
                {`${job.title}`}
            </S.TextTd>
            <S.TextTd>
                <Profile id={job.assigned_staff} />
            </S.TextTd>
            <S.TextTd>
                {
                    job.published
                        ? <span className="text-success">{_('booth.jobs.status.published')}</span>
                        : <span className="text-info">{_('booth.jobs.status.draft')}</span>
                }
            </S.TextTd>
            <td style={{ width: 110 }}>
                <Icon icon="view" onClick={onView} className="mr-1" />
                <Icon icon="edit" onClick={onEdit} className="mr-1" />
                <Icon icon="trash" onClick={onDelete} />
            </td>
        </tr>
    )
}

const JobTable = ({ jobList }: { jobList: Job[] }) => (
    <Table hover>
        <thead>
            <tr>
                <th>{_('booth.jobs.list.table_headers.title')}</th>
                <th>{_('booth.jobs.list.table_headers.assigned_staff')}</th>
                <th>{_('booth.jobs.list.table_headers.published')}</th>
                <th> </th>
            </tr>
        </thead>
        <tbody>
            {
                jobList.map((job) => (
                    <JobRow job={job} key={job.id} />
                ))
            }
        </tbody>
    </Table>
)

const JobsOverview = () => {
    const jobList = useSelector(selectJobs)

    if (!jobList || jobList.length === 0) {
        return <h6>{_('booth.jobs.list.is_empty')}</h6>
    }

    return (
        <JobTable jobList={jobList} />
    )
}

export default JobsOverview
